/**
 * Identifies which sidebar Dropdown should stay expanded based on current route.
 * Keep in sync with links inside SidebarContent.jsx Dropdowns.
 */

export const SIDEBAR_DROPDOWN_GROUP = {
  AGENCY: 'agency',
  CUSTOMERS: 'customers',
  COMMISSIONS: 'commissions',
  MARKETING: 'marketing',
  OFF_MARKET_TOOLS: 'off-market-tools'
};

const pathIsAgencyDashboard = pathname =>
  /^\/agency\/dashboard\/[^/]+$/.test(pathname ?? '');
const pathIsAgencySettings = pathname =>
  /^\/agency\/settings\/[^/]+$/.test(pathname ?? '');
const pathIsAgencyAppointments = pathname =>
  /^\/agency\/appointments\/[^/]+$/.test(pathname ?? '');

const COMMISSIONS_ROUTE_TYPES = new Set([
  'statements',
  'rates',
  'bonuses',
  'book-of-business'
]);

export function getActiveSidebarDropdownGroup({
  pathname = '',
  activePage,
  type,
  company
}) {
  const p = pathname || '';

  if (
    pathIsAgencyDashboard(p) ||
    pathIsAgencySettings(p) ||
    pathIsAgencyAppointments(p) ||
    p === '/agency/hierarchy'
  ) {
    return SIDEBAR_DROPDOWN_GROUP.AGENCY;
  }

  if (
    p.startsWith('/customers/policies') ||
    p.startsWith('/customers/book-of-business') ||
    p.startsWith('/customers/risk-management') ||
    p.startsWith('/customers/commission-reconciliation')
  ) {
    return SIDEBAR_DROPDOWN_GROUP.CUSTOMERS;
  }

  if (
    activePage === 'Customers' ||
    activePage === 'CustomersBob' ||
    activePage === 'Risk Management' ||
    activePage === 'CustomersCommissionsReco'
  ) {
    return SIDEBAR_DROPDOWN_GROUP.CUSTOMERS;
  }

  if (p.startsWith('/commissions/')) {
    return SIDEBAR_DROPDOWN_GROUP.COMMISSIONS;
  }

  if (activePage === 'Commissions' || activePage === 'CustomersCommissions') {
    return SIDEBAR_DROPDOWN_GROUP.COMMISSIONS;
  }

  if (type && COMMISSIONS_ROUTE_TYPES.has(type)) {
    return SIDEBAR_DROPDOWN_GROUP.COMMISSIONS;
  }

  if (
    company === 'oneill' &&
    (p.startsWith('/marketing/content-library') ||
      p.startsWith('/marketing/leads'))
  ) {
    return SIDEBAR_DROPDOWN_GROUP.MARKETING;
  }

  if (company === 'oneill' && activePage === 'Marketing Services') {
    return SIDEBAR_DROPDOWN_GROUP.MARKETING;
  }

  if (
    company === 'oneill' &&
    (p === '/handbook' ||
      p.startsWith('/off-market/') ||
      activePage === 'Off-Market Tools' ||
      activePage === 'Bookshelf')
  ) {
    return SIDEBAR_DROPDOWN_GROUP.OFF_MARKET_TOOLS;
  }

  return null;
}
